import { Autocomplete, Box, Button, IconButton, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { showNotification } from "../../../../common/Notification/ToastifyNotification";
import { apiRequest } from "../../../../common/common";
import { LoadingPage } from "../../../../common/LoadingPage";
import { Delete } from "@mui/icons-material";
import { Scope, TwoDAccess, ThreeDAccess } from "../../../../common/const";
import { useSelector } from "react-redux";

const Cell = styled(TableCell)({
  padding: '0px 0px 0px 20px'
});

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const Resource = ({
  itemData,
  getInitialData
}) => {
  const { roles, user } = useSelector(state => state.users);
  const isUser = roles.find((a) => a.id === user?.role_id);
  const currentPlanId = user?.organization?.Subscriptions[0]?.plan_id;
  const [dataLoading, setDataLoading] = useState(false);
  const [resources, setResource] = useState(null);
  const [scope, setScope] = useState(itemData?.document_scope || Scope[0]?.value);
  const [rows, setRows] = useState([
    { extension: '--', type: 'Image', resource: '--', size: '--', sortUrl: '' },
    { extension: '--', type: 'Product Specification', resource: '--', size: '--', sortUrl: '' },
    { extension: '--', type: 'Product Brochure', resource: '--', size: '--', sortUrl: '' },
    { extension: '--', type: 'Product Planning', resource: '--', size: '--', sortUrl: '' },
    { extension: '--', type: 'Product Operating Manual', resource: '--', size: '--', sortUrl: '' },
    { extension: '--', type: 'URL', resource: '--', size: '--', sortUrl: '' },
    { extension: '--', type: '2D', resource: '--', size: '--', sortUrl: '' },
    { extension: '--', type: '3D', resource: '--', size: '--', sortUrl: '' },
    { extension: '--', type: 'Other Document 1', resource: '--', size: '--', sortUrl: '' },
    { extension: '--', type: 'Other Document 2', resource: '--', size: '--', sortUrl: '' },
    { extension: '--', type: 'Other Document 3', resource: '--', size: '--', sortUrl: '' },
  ]);

  useEffect(() => {
    if (itemData?.product) {
      const getFileData = (key) => {
        const file = itemData?.[key]?.[0] || itemData?.product?.[key]?.[0];
        if (!file) return {};
        return {
          resource: file?.fileName || file?.sortUrl.split('/').pop().split('&')[0].split(/\.(?=[^\.]+$)/)[0],
          size: file.size ? `${(file.size / 1024).toFixed(2)} KB` : '--',
          extension: file?.fileName?.split('.')?.pop() || file?.sortUrl.split('/').pop().split('&')[0].split(/\.(?=[^\.]+$)/)[1] || '--',
          sortUrl: file?.sortUrl
        };
      };
      setRows((prevData) =>
        prevData.map((row) => {
          if (row.type === 'Image') {
            return { ...row, ...getFileData('images') };
          }
          if (row.type === 'Product Specification') {
            return { ...row, ...getFileData('specifications_doc') };
          }
          if (row.type === 'Product Brochure') {
            return { ...row, ...getFileData('brochure_doc') };
          }
          if (row.type === 'Product Planning') {
            return { ...row, ...getFileData('site_planning_doc') };
          }
          if (row.type === 'Product Operating Manual') {
            return { ...row, ...getFileData('operating_manual_doc') };
          }
          if (row.type === '2D') {
            return { ...row, ...getFileData('twod_doc') };
          }
          if (row.type === '3D') {
            return { ...row, ...getFileData('threed_doc') };
          }
          if (row.type === 'URL') {
            const resourceValue = itemData?.product?.["website_url"]?.length === 0 ? '--' : itemData?.product?.["website_url"].toString();
            return {
              ...row,
              resource: resourceValue,
              extension: resourceValue !== '--' ? 'URL' : '--',
            };
          }
          if (row.type === 'Other Document 1') {
            return { ...row, ...getFileData('other_doc1') };
          }
          if (row.type === 'Other Document 2') {
            return { ...row, ...getFileData('other_doc2') };
          }
          if (row.type === 'Other Document 3') {
            return { ...row, ...getFileData('other_doc3') };
          }
          return row;
        })
      );
    }
  }, [itemData]);

  const handleFileUpload = (event, fileType) => {
    const file = event.target.files[0];
    if (file) {
      setResource((prevData) => ({
        ...prevData,
        [fileType.toLowerCase().replace(/\s+/g, '')]: file,
      }));
      setRows((prevData) =>
        prevData.map((row) => {
          if (row.type === fileType) {
            return {
              ...row,
              resource: file.name,
              size: `${(file.size / 1024).toFixed(2)} KB`,
              extension: file.name.split('.').pop(),
            };
          }
          return row;
        })
      );
    }
  };

  const handleRemove = (fileType) => {
    setResource((prevData) => {
      const updatedData = { ...prevData };
      const key = fileType.toLowerCase().replace(/\s+/g, '');
      delete updatedData[key];
      return updatedData;
    });

    setRows((prevData) =>
      prevData.map((row) => {
        if (row.type === fileType) {
          return {
            ...row,
            resource: '--',
            size: '--',
            extension: '--',
          };
        }
        return row;
      })
    );
  }

  console.log(itemData);

  const handleSubmit = async () => {
    if (scope !== null) {
      setDataLoading(true);
      const formData = new FormData();
      if (resources?.otherdocument1) {
        formData.append('other_doc1', resources?.otherdocument1);
      }
      if (resources?.otherdocument2) {
        formData.append('other_doc2', resources?.otherdocument2);
      }
      if (resources?.otherdocument3) {
        formData.append('other_doc3', resources?.otherdocument3);
      }
      formData.append('document_scope', scope)
      try {
        if (itemData?.item_id) {
          const response = await apiRequest('put', `/project-item/${itemData?.item_id}`, formData);
          if (response?.data) {
            showNotification(response?.data?.message, 'success');
            getInitialData();
            setResource(null);
            setDataLoading(false);
          }
        }
      } catch (error) {
        setDataLoading(false);
        showNotification(error?.response?.data.error || error.message, 'error');
      }
    } else {
      showNotification('Please select scope of document', 'error');
    }
  }

  return (
    <>
      {dataLoading && (<LoadingPage isLoading={dataLoading} />)}
      <Box display="flex" justifyContent="space-between" alignItems="center" mt={1}>
        <Typography varaint="body1" style={{ fontWeight: 'bold' }}>Resources</Typography>
        {resources !== null && Object.keys(resources).length > 0 && (
          <Box display="flex" alignItems="center" gap={1} sx={{ width: '30%' }}>
            <Autocomplete
              value={Scope.find((c) => c.value === scope) || null}
              id="combo-box-demo"
              size="small"
              fullWidth
              options={Scope}
              clearIcon={null}
              getOptionLabel={(option) => option?.name}
              onChange={(event, newValue) => {
                setScope(newValue?.value || null);
              }}
              renderInput={(params) => <TextField fullWidth {...params} label="Document Scope" name="Document Scope" variant="outlined" />}
            />
            <Button
              color="primary"
              size="medium"
              variant="contained"
              style={{
                float: 'right',
              }}
              onClick={() => handleSubmit()}
            >
              Upload
            </Button>
          </Box>
        )}
      </Box>
      <Box sx={{ width: '100%', overflowX: 'auto', border: '1px solid lightgrey', marginTop: 1 }}>
        <TableContainer>
          <Table sx={{ minWidth: 650 }} aria-label="responsive table">
            <TableHead>
              <TableRow>
                <Cell>Extension</Cell>
                <Cell>Type</Cell>
                <Cell>Resource</Cell>
                <Cell>Size</Cell>
                <Cell>Document Scope</Cell>
                <Cell>Action</Cell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, index) => {
                const is2D = row.type === '2D';
                const is3D = row.type === '3D';
                const isAdmin = ['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code);

                // Determine if the current plan allows access based on type
                const hasAccess2D = is2D && (isAdmin || TwoDAccess.includes(currentPlanId));
                const hasAccess3D = is3D && (isAdmin || ThreeDAccess === currentPlanId);
                const hasAccessOtherTypes = !is2D && !is3D;

                // Calculate the button's disabled state based on the conditions
                const isButtonDisabled = !(hasAccess2D || hasAccess3D || hasAccessOtherTypes);
                return (
                  <TableRow key={index} sx={{ padding: 10 }}>
                    <Cell>
                      <Box style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                        {(row.extension !== '--' && row?.type === 'Image') ? (
                          <img src="/images/gallary.png" alt="blog img" style={{ width: 20 }} />
                        ) : (row.extension !== '--' && row?.type === '2D') ? (
                          <img src="/images/autocad.png" alt="blog img" style={{ width: 20 }} />
                        ) : (row.extension !== '--' && row?.type === '3D') ? (
                          <img src="/images/ravit.jpeg" alt="blog img" style={{ width: 20 }} />
                        ) : (row.extension !== '--' && row?.type === 'URL') ? (
                          <img src="/images/URL.png" alt="blog img" style={{ width: 20 }} />
                        ) : row.extension !== '--' && (
                          <img src="/images/pdf.svg" alt="blog img" style={{ width: 15 }} />
                        )}
                        {row.extension}
                      </Box>
                    </Cell>
                    <Cell>{row.type}</Cell>
                    <Cell>
                      {row.type === 'URL' ? (
                        row?.resource !== '--' && row?.resource?.split(',').map((a) => (
                          <>
                            <Tooltip title={a}>
                              <a href={a} target="_blank" rel="noreferrer">{a.slice(0, 50)}</a>
                            </Tooltip>
                            <br />
                          </>
                        ))
                      ) :
                        row.resource}
                    </Cell>
                    <Cell>{row.size}</Cell>
                    <Cell>
                      {['Other Document 1', 'Other Document 2', 'Other Document 3'].includes(row.type)
                        ? (itemData?.document_scope || itemData?.scope || '--')
                        : '--'
                      }
                    </Cell>
                    <Cell>
                      {row.extension !== '--' && row.type !== 'URL' ? (
                        <Box style={{ display: 'flex', alignItems: 'center' }}>
                          <Box style={{ paddingTop: '7px' }}>
                            <a
                              href='#'
                              style={{ color: isButtonDisabled ? 'gray' : '' }}
                              onClick={async () => {
                                if (!isButtonDisabled) {
                                  const url = `${process.env.REACT_APP_IMAGEURL}bbn=${row?.sortUrl}&uid=${user?.user_id}`;
                                  const response = await fetch(url, { method: 'GET' });
                                  const blob = await response.blob();
                                  const link = document.createElement('a');
                                  link.href = window.URL.createObjectURL(blob);
                                  link.download = `${row?.resource}`; // <-- set file name here
                                  link.click();
                                }
                              }}>
                              <FileDownloadIcon />
                            </a>
                          </Box>
                          {['Other Document 1', 'Other Document 2', 'Other Document 3']?.includes(row.type) && (
                            <IconButton onClick={() => handleRemove(row.type)} style={{ padding: 0 }}>
                              <Delete color="secondary" />
                            </IconButton>
                          )}
                        </Box>
                      ) : ['Other Document 1', 'Other Document 2', 'Other Document 3']?.includes(row.type) ? (
                        <IconButton component="label" style={{ padding: 0 }}>
                          <CloudUploadIcon />
                          <VisuallyHiddenInput
                            type="file"
                            onChange={(event) => handleFileUpload(event, row.type)}
                            accept=".pdf"
                          />
                        </IconButton>
                      ) : '--'}
                    </Cell>
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </>
  )
};

export default Resource;